import styled from '@emotion/styled';

export const Container = styled.main`
	display: flex;
	flex-direction: column;
	gap: 8rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding-top: 8rem;
	@media screen and (max-width: 900px) {
		padding: 8rem 2rem 0rem 2rem;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;

export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const BasicInfoBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;
export const BasicInfoButtonBox = styled.div`
	display: flex;
	gap: 0.8rem;

	@media screen and (max-width: 900px) {
		flex-direction: column;
	}
`;
export const BasicInfo = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #212529;
	li {
		position: relative;
		padding-left: 1.5rem;
		&::after {
			content: '';
			position: absolute;
			top: calc(0.8em - 7px);
			left: 0;
			background-color: currentColor;
			width: 4px;
			height: 4px;
			border-radius: 50%;
		}
	}
`;
export const BlueInput = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0rem 1.2rem;
	gap: 0.2rem;
	height: 100%;
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	border: 1px solid ${(props) => props.theme.colors.primary400};
	min-width: 18rem;
	height: 4.4rem;
	cursor: pointer;
`;
export const BlueButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0rem 1.2rem;
	gap: 0.2rem;
	height: 100%;
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	border: 1px solid ${(props) => props.theme.colors.primary400};
	min-width: 18rem;
	height: 4.4rem;
	cursor: pointer;
`;

export const WhiteButton = styled(BlueButton)`
	background-color: #fff;
	color: ${(props) => props.theme.colors.primary400};
`;
export const BlackButton = styled.a`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0rem 1.2rem;
	height: 100%;
	color: #fff;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	border: 1px solid ${(props) => props.theme.colors.primary400};
	min-width: 18rem;
	height: 4.4rem;
	cursor: pointer;
	background-color: #212529;
	color: #fff;
	gap: 0.8rem;
`;

export const HighlightBox = styled.div`
	display: flex;
	gap: 1rem;
	padding: 2rem;
	background-color: #f1f3f5;
	font-size: 1.8rem;
	font-weight: 600;
	line-height: 130%;
	letter-spacing: -0.6px;
	.point {
		color: #47a3f3;
	}
`;

export const SubMenuBox = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	li {
		position: relative;
		padding-left: 1.5rem;
		font-size: 1.6rem;
		font-weight: 400;
		line-height: 140%;
		letter-spacing: -0.6px;
		&::after {
			content: '';
			position: absolute;
			top: calc(0.8em - 7px);
			left: 0;
			background-color: currentColor;
			width: 4px;
			height: 4px;
			border-radius: 50%;
		}
	}
`;
export const SubTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
